import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Communicaiton = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.925.62c-.2-.5-.9-.8-1.4-.5L.7 17.15c-.4.2-.7.601-.7 1.002 0 .4.3.801.7 1.002l18.31 5.81L24.815 43.3c.1.4.5.701 1 .701.501 0 .801-.2 1.001-.701l17.11-41.877c.1-.2.1-.6 0-.801ZM4.102 18.054l34.42-14.126-18.91 18.934-15.51-4.808Zm21.813 21.84-4.903-15.529L40.022 5.43 25.916 39.892Z"
  }));
});
Communicaiton.displayName = 'Communicaiton';
Communicaiton.defaultProps = {
  'aria-label': 'Communicaiton'
};
export default Communicaiton;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Subject/Communicaiton.js
// module id = 2998
// module chunks = 11